// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // kia project details
  apiKey: "AIzaSyB3YdxK4i-4mItfzEbCh6bCbFvLxUDOpQY",
  authDomain: "kia-hyperlocal.firebaseapp.com",
  databaseURL: "https://kia-hyperlocal.firebaseio.com",
  projectId: "kia-hyperlocal",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;